const numberRepresentation = /^[\d\s\u00BC-\u00BE\u2150-\u215E]+$/;

export const isNumberRepresentation = (candidate: string) => numberRepresentation.test(candidate);
